import React, { useState } from 'react';

import { parseSmallAmount, parseFullAmount } from "../common-helpers";
import { getTotalAmount } from './helpers';

export interface ICategory {
    categoryIndex: number,
    fields: { title: string, description?: string }[],
    resetHandlers: (() => void)[],
    title: string,
    updateCategory: (amount: number, id: number) => void,
}

const Category: React.FC<ICategory> = ({
    categoryIndex,
    fields,
    resetHandlers,
    title,
    updateCategory,
  }) => {

  const [values, setValues] = useState(Array.from({ length: fields.length }, () => ''));

  const onChange: React.ChangeEventHandler<HTMLInputElement> = ({ currentTarget }) => {
    const { value, dataset: { index } } = currentTarget;

    if (!value.length) { return; }

    const updatedValues = values.map((val, i) => (index && +index === i ? parseSmallAmount(value, 16) : val));
    setValues(updatedValues);
    updateCategory(getTotalAmount(updatedValues), categoryIndex);
  };

  const onBlur: React.FocusEventHandler<HTMLInputElement> = ({ currentTarget }) => {
    const { value, dataset: { index } } = currentTarget;

    if (!value.length) { return; }

    setValues(values.map((val, i) => (index && +index === i ? parseFullAmount(value) : val)));
  };

  const clearValues = () => {
    setValues(values.map(() => ''));
  };

  resetHandlers.push(clearValues);

  return (
    <div className="netWorth-category">
      <div className="netWorth-category-title">{title}</div>
      {fields && fields.map((field: { title: string, description?: string }, index: number) => (
        <div className="netWorth-category-field" key={`category-field-${index}`}>
					<div className="netWorth-category-field-title">
						{field.title}
					</div>
					<input
						className="netWorth-category-field-input"
						data-categoryindex={categoryIndex}
						data-index={index}
						onChange={onChange}
						onBlur={onBlur}
						placeholder="$0.00"
						title={field.title}
						type="text"
            inputMode="numeric"
						value={values[index]}
					/>
					<div className="netWorth-category-field-description">{field.description}</div>
				</div>
      ))}
    </div>
  );
};

Category.defaultProps = {
  fields: [],
};

export default Category;
